import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Lang from './Lang';



export default function ImageDownloaderGetCode(props){
const {language} = useParams();
    let lang = language;
    document.title = "Image downloader";
    const locals = ['pt','es','fr','de','it','hu','tr','ru','he','vi','th','ko','zh_CN','zh_TW','ja'];                
    if(!locals.includes(lang)){
      lang='en';
    }
    const translation = {
      en:["A subscription is required in order to unlock the sort option.",
        "A 3-month subscription costs $9.95/month × 3 months = $29.85, but is currently offered at just $9.95.",
      "How do I sign up?",
      "Contact us using the form at the link below and request a subscription. Be sure to provide the email address you'd like to use. You will receive instructions on where to send the payment via PayPal. Once we receive your payment (within 48 hours), we will send you the activation code.",
    "Important:",
    "You must contact us and wait for our reply before sending any payment, even if you already know where to send it. This ensures we can confirm receipt and verify that we are available to process your subscription."
  ,"Contact us form link"],
      fr: [
  "Un abonnement est requis pour débloquer l'option de tri.",
  "Un abonnement de 3 mois coûte 9,95 $/mois × 3 mois = 29,85 $, mais il est actuellement proposé pour seulement 9,95 $.",
  "Comment puis-je m'abonner ?",
  "Contactez-nous en utilisant le formulaire au lien ci-dessous et demandez un abonnement. Veillez à fournir l'adresse e-mail que vous souhaitez utiliser. Vous recevrez des instructions sur la façon d’envoyer le paiement via PayPal. Une fois le paiement reçu (sous 48 heures), nous vous enverrons le code d’activation.",
  "Important :",
  "Vous devez nous contacter et attendre notre réponse avant d’envoyer tout paiement, même si vous savez déjà où l’envoyer. Cela nous permet de confirmer la réception et de vérifier que nous sommes disponibles pour traiter votre abonnement.",
  "Lien vers le formulaire de contact"
],
es: [
  "Se requiere una suscripción para desbloquear la opción de ordenar.",
  "Una suscripción de 3 meses cuesta $9.95/mes × 3 meses = $29.85, pero actualmente se ofrece por solo $9.95.",
  "¿Cómo me suscribo?",
  "Contáctanos usando el formulario en el enlace a continuación y solicita una suscripción. Asegúrate de proporcionar la dirección de correo electrónico que deseas utilizar. Recibirás instrucciones sobre cómo enviar el pago a través de PayPal. Una vez que recibamos tu pago (dentro de 48 horas), te enviaremos el código de activación.",
  "Importante:",
  "Debes contactarnos y esperar nuestra respuesta antes de enviar cualquier pago, incluso si ya sabes dónde enviarlo. Esto asegura que podamos confirmar la recepción y verificar que estamos disponibles para procesar tu suscripción.",
  "Enlace al formulario de contacto"
],
pt: [
  "É necessária uma assinatura para desbloquear a opção de ordenação.",
  "Uma assinatura de 3 meses custa R$9,95/mês × 3 meses = R$29,85, mas está sendo oferecida por apenas R$9,95.",
  "Como faço para assinar?",
  "Entre em contato conosco usando o formulário no link abaixo e solicite uma assinatura. Certifique-se de fornecer o endereço de e-mail que deseja usar. Você receberá instruções sobre como enviar o pagamento via PayPal. Assim que recebermos seu pagamento (em até 48 horas), enviaremos o código de ativação.",
  "Importante:",
  "Você deve nos contatar e aguardar nossa resposta antes de enviar qualquer pagamento, mesmo que já saiba para onde enviá-lo. Isso garante que possamos confirmar o recebimento e verificar se estamos disponíveis para processar sua assinatura.",
  "Link para o formulário de contato"
],
ru: [
  "Для разблокировки функции сортировки требуется подписка.",
  "Подписка на 3 месяца стоит $9.95/месяц × 3 месяца = $29.85, но сейчас доступна всего за $9.95.",
  "Как оформить подписку?",
  "Свяжитесь с нами через форму по ссылке ниже и запросите подписку. Обязательно укажите адрес электронной почты, который вы хотите использовать. Вы получите инструкции по оплате через PayPal. После получения оплаты (в течение 48 часов) мы отправим вам код активации.",
  "Важно:",
  "Перед отправкой оплаты вы должны связаться с нами и дождаться ответа, даже если уже знаете, куда отправлять. Это необходимо для подтверждения получения и проверки нашей доступности для обработки вашей подписки.",
  "Ссылка на форму обратной связи"
],
de: [
  "Ein Abonnement ist erforderlich, um die Sortieroption freizuschalten.",
  "Ein 3-Monats-Abonnement kostet 9,95 $/Monat × 3 Monate = 29,85 $, wird aber derzeit für nur 9,95 $ angeboten.",
  "Wie kann ich mich anmelden?",
  "Kontaktieren Sie uns über das Formular im untenstehenden Link und fordern Sie ein Abonnement an. Geben Sie unbedingt die E-Mail-Adresse an, die Sie verwenden möchten. Sie erhalten Anweisungen zur Zahlung per PayPal. Sobald wir Ihre Zahlung erhalten haben (innerhalb von 48 Stunden), senden wir Ihnen den Aktivierungscode.",
  "Wichtig:",
  "Sie müssen uns kontaktieren und auf unsere Antwort warten, bevor Sie eine Zahlung senden, selbst wenn Sie bereits wissen, wohin sie gesendet werden soll. So stellen wir sicher, dass wir den Zahlungseingang bestätigen und Ihre Anmeldung bearbeiten können.",
  "Link zum Kontaktformular"
],
hu: [
  "A rendezési lehetőség feloldásához előfizetés szükséges.",
  "A 3 hónapos előfizetés ára 9,95 USD/hó × 3 hónap = 29,85 USD, de jelenleg mindössze 9,95 USD-ért elérhető.",
  "Hogyan tudok előfizetni?",
  "Lépj kapcsolatba velünk az alábbi linken található űrlap segítségével, és kérj előfizetést. Feltétlenül add meg azt az e-mail címet, amelyet használni szeretnél. Ezt követően megkapod az utasításokat a PayPal-on keresztüli fizetéshez. A fizetés beérkezését követően (48 órán belül) elküldjük az aktivációs kódot.",
  "Fontos:",
  "A fizetés elküldése előtt mindenképpen lépj kapcsolatba velünk, és várd meg a válaszunkat, még akkor is, ha már tudod, hová kell küldeni. Ez biztosítja, hogy meg tudjuk erősíteni a befizetésedet, és hogy elérhetőek vagyunk az előfizetés feldolgozásához.",
  "Kapcsolatfelvételi űrlap linkje"
],
he: [
  "נדרש מנוי כדי לפתוח את אפשרות המיון.",
  "מנוי לשלושה חודשים עולה ‎$9.95 לחודש × 3 חודשים = ‎$29.85, אך כעת מוצע במחיר של ‎$9.95 בלבד.",
  "איך נרשמים?",
  "צרו איתנו קשר דרך הטופס בקישור למטה ובקשו מנוי. הקפידו לציין את כתובת האימייל שברצונכם להשתמש בה. תקבלו הנחיות כיצד לשלוח את התשלום באמצעות PayPal. לאחר שנקבל את התשלום (תוך 48 שעות), נשלח אליכם את קוד ההפעלה.",
  "חשוב:",
  "חובה לפנות אלינו ולהמתין לתשובה שלנו לפני שליחת כל תשלום, גם אם אתם כבר יודעים לאן לשלוח. זה מבטיח שנוכל לאשר את הקבלה ולוודא שאנו זמינים לעיבוד המנוי שלכם.",
  "קישור לטופס יצירת קשר"
],
tr: [
  "Sıralama seçeneğinin kilidini açmak için bir abonelik gereklidir.",
  "3 aylık abonelik ücreti aylık 9,95 $ × 3 ay = 29,85 $’dır, ancak şu anda yalnızca 9,95 $’a sunulmaktadır.",
  "Nasıl abone olabilirim?",
  "Aşağıdaki bağlantıdaki formu kullanarak bizimle iletişime geçin ve bir abonelik talep edin. Kullanmak istediğiniz e-posta adresini mutlaka belirtin. PayPal üzerinden ödeme göndermeniz için talimatları alacaksınız. Ödemeniz alındıktan sonra (48 saat içinde) size etkinleştirme kodunu göndereceğiz.",
  "Önemli:",
  "Ödemeyi göndermeden önce bizimle iletişime geçip yanıtımızı beklemelisiniz – nereye göndereceğinizi biliyor olsanız bile. Bu, ödemeyi aldığımızı onaylamamızı ve aboneliğinizi işleme koymaya hazır olduğumuzu garanti eder.",
  "İletişim formu bağlantısı"
],
it: [
  "È necessario un abbonamento per sbloccare l'opzione di ordinamento.",
  "Un abbonamento di 3 mesi costa $9,95/mese × 3 mesi = $29,85, ma attualmente è offerto a soli $9,95.",
  "Come posso abbonarmi?",
  "Contattaci utilizzando il modulo al link qui sotto e richiedi un abbonamento. Assicurati di fornire l'indirizzo email che desideri utilizzare. Riceverai le istruzioni su come inviare il pagamento tramite PayPal. Una volta ricevuto il pagamento (entro 48 ore), ti invieremo il codice di attivazione.",
  "Importante:",
  "È necessario contattarci e attendere la nostra risposta prima di inviare qualsiasi pagamento, anche se sai già dove inviarlo. Questo ci consente di confermare la ricezione e verificare di essere disponibili per elaborare il tuo abbonamento.",
  "Link al modulo di contatto"
],
th: [
  "ต้องมีการสมัครสมาชิกเพื่อปลดล็อกตัวเลือกการจัดเรียง",
  "การสมัครสมาชิก 3 เดือน มีค่าใช้จ่าย $9.95/เดือน × 3 เดือน = $29.85 แต่ขณะนี้เสนอในราคาเพียง $9.95",
  "ฉันจะสมัครสมาชิกได้อย่างไร?",
  "ติดต่อเราผ่านแบบฟอร์มที่ลิงก์ด้านล่างและขอสมัครสมาชิก อย่าลืมระบุที่อยู่อีเมลที่คุณต้องการใช้ คุณจะได้รับคำแนะนำเกี่ยวกับวิธีชำระเงินผ่าน PayPal เมื่อเราได้รับการชำระเงินของคุณ (ภายใน 48 ชั่วโมง) เราจะส่งรหัสเปิดใช้งานให้คุณ",
  "สำคัญ:",
  "คุณต้องติดต่อเราและรอการตอบกลับก่อนที่จะส่งการชำระเงิน แม้ว่าคุณจะรู้แล้วว่าจะต้องส่งไปที่ใดก็ตาม เพื่อให้เรายืนยันการรับเงินและตรวจสอบว่าเราพร้อมให้บริการในการดำเนินการสมัครของคุณ",
  "ลิงก์แบบฟอร์มติดต่อเรา"
],
vi: [
  "Cần có đăng ký để mở khóa tùy chọn sắp xếp.",
  "Gói đăng ký 3 tháng có giá $9.95/tháng × 3 tháng = $29.85, nhưng hiện đang được ưu đãi chỉ với $9.95.",
  "Làm sao để đăng ký?",
  "Liên hệ với chúng tôi qua biểu mẫu tại liên kết bên dưới và yêu cầu đăng ký. Hãy đảm bảo cung cấp địa chỉ email bạn muốn sử dụng. Bạn sẽ nhận được hướng dẫn cách thanh toán qua PayPal. Sau khi chúng tôi nhận được thanh toán của bạn (trong vòng 48 giờ), chúng tôi sẽ gửi mã kích hoạt cho bạn.",
  "Quan trọng:",
  "Bạn phải liên hệ với chúng tôi và chờ phản hồi trước khi gửi bất kỳ khoản thanh toán nào, ngay cả khi bạn đã biết nơi cần gửi. Điều này đảm bảo rằng chúng tôi có thể xác nhận đã nhận được và sẵn sàng xử lý đăng ký của bạn.",
  "Liên kết đến biểu mẫu liên hệ"
],
ko: [
  "정렬 옵션을 활성화하려면 구독이 필요합니다.",
  "3개월 구독은 월 $9.95 × 3개월 = $29.85이지만, 현재 단 $9.95에 제공되고 있습니다.",
  "구독은 어떻게 하나요?",
  "아래 링크의 양식을 통해 저희에게 연락하시고 구독을 요청해 주세요. 사용하고 싶은 이메일 주소를 반드시 제공해 주세요. PayPal로 결제하는 방법에 대한 안내를 받게 됩니다. 결제를 확인한 후 (48시간 이내), 활성화 코드를 보내드립니다.",
  "중요:",
  "결제를 보내기 전에 반드시 저희에게 먼저 연락하여 답변을 기다려야 합니다. 이미 결제 정보를 알고 있더라도 마찬가지입니다. 이렇게 해야 결제 수령을 확인하고 구독 처리를 준비할 수 있습니다.",
  "문의 양식 링크"
],
ja: [
  "並び替えオプションを有効にするにはサブスクリプションが必要です。",
  "3か月のサブスクリプションは月額9.95ドル × 3か月 = 29.85ドルですが、現在はわずか9.95ドルで提供されています。",
  "どうやって申し込めばいいですか？",
  "以下のリンクにあるフォームからお問い合わせいただき、サブスクリプションをリクエストしてください。使用したいメールアドレスを必ずご記入ください。PayPalによる支払い方法の案内をお送りします。お支払いの確認後（48時間以内）に、アクティベーションコードをお送りします。",
  "重要：",
  "支払いを送る前に、必ずお問い合わせいただき、返信をお待ちください。すでに送付先をご存じでも同様です。これにより、支払いの確認とサブスクリプションの処理が確実に行えます。",
  "お問い合わせフォームのリンク"
],
zh_CN: [
  "需要订阅才能解锁排序功能。",
  "3个月订阅费用为$9.95/月 × 3个月 = $29.85，但目前仅需$9.95。",
  "我该如何订阅？",
  "请通过下方链接中的表单联系我们并申请订阅。请务必提供您希望使用的电子邮箱地址。您将收到通过 PayPal 支付的说明。我们在收到您的付款后（48小时内）将发送激活码给您。",
  "重要提示：",
  "请务必在付款前与我们联系并等待回复，即使您已经知道付款地址。这可以确保我们确认收款并准备好处理您的订阅。",
  "联系我们表单链接"
],
zh_TW: [
  "需要訂閱才能解鎖排序功能。",
  "3 個月的訂閱費用為 $9.95/月 × 3 個月 = $29.85，但目前只需 $9.95。",
  "我該如何訂閱？",
  "請透過下方連結中的表單與我們聯繫並申請訂閱。請務必提供您想使用的電子郵件地址。我們會提供如何透過 PayPal 付款的說明。收到您的付款後（48 小時內），我們將寄送啟用碼給您。",
  "重要：",
  "請務必先與我們聯繫並等待回覆後再進行付款，即使您已經知道付款資訊。這樣我們才能確認收款並處理您的訂閱。",
  "聯絡我們表單連結"
]


    }
    const contactLink = "../../contact/"+lang;
    return(
<div style={{direction: lang != 'he' ? 'ltr' : 'rtl'}}>
        <Lang />
  <div style={{ color: "white" }}>
    <h2>
    <p>{translation[lang][0]}<br/> 
    </p>
{translation[lang][1]}
    <p><u>{translation[lang][2]}</u></p>
    {translation[lang][3]}
    

    <p><b style={{ color: "orange" }}>{translation[lang][4]} </b> 
    {translation[lang][5]}
    </p>
    <NavLink to={contactLink}>{translation[lang][6]}</NavLink>
    </h2>
  </div>
</div>
    )
}